//console.log('Hello from bottom.js webpack')

// functions that need to load after the dom tree is complete
require("emailobfuscator")
require("embedded_player")

